export default [
  {
    name: 'Digitale Hoogtemodel Vlaanderen ',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/DHMV/wms',
    sublayers: [
      { id: 'DHMV_II_HILL_25cm', title: 'Multidirectionale hillshade 0,25 m' },
      { id: 'DHMV_II_SVF_25cm', title: 'Skyview factor 0,25 m' },
      { id: 'DHMVII_DTM_1m', title: 'Digitaal terreinmodel 1m' },
      { id: 'DHMVII_DSM_1m', title: 'Digitaal oppervlaktemodel 1m' }
    ]
  },
  {
    name: 'Gemeentegrens',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/GRB/wms?',
    sublayers: [{ id: 'GEM_GRENS', title: 'GEM - gemeentegrens' },
      { id: 'GRB_ADP', title: 'GRB - ADP - administratief perceel' }]
  },
  {
    name: 'Grootschalig Referentiebestand - 3D Gebouw LOD 1',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/3DGRB/wms?',
    sublayers: [{ id: 'GRBGEBL1D2', title: '3D GRB Gebouw LOD 1 DHMV IIp' }]
  },
  {
    // ORTHO_2025_ETE only covers part of Wallonia; the spring flight is region-wide
    name: 'Orthophotos Wallonie 2025 (printemps)',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/IMAGERIE/ORTHO_2025_PRINTEMPS/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'Orthophotos 2025 printemps' }],
    invertMapTextColour: false
  },
  {
    name: 'Orthophotos Wallonie – dernière disponibilité',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/IMAGERIE/ORTHO_LAST/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'Dernière orthophoto' }],
    invertMapTextColour: false
  },
  {
    name: 'Orthophotos Wallonie – dernière IR',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/IMAGERIE/ORTHO_LAST_IR/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'Dernière orthophoto IR' }],
    invertMapTextColour: false
  },
  {
    name: 'Relief Wallonie – MNS 2021-2022 (50 cm)',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/RELIEF/WALLONIE_MNS_2021_2022/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'MNS 50 cm 2021-2022' }],
    invertMapTextColour: true
  },
  {
    name: 'Relief Wallonie – MNS 2021-2022 Hillshade',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/RELIEF/WALLONIE_MNS_2021_2022_HILLSHADE/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'Hillshade MNS 2021-2022' }],
    invertMapTextColour: true
  },
  {
    name: 'Relief Wallonie – MNT 2021-2022',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/RELIEF/WALLONIE_MNT_2021_2022/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'MNT 2021-2022' }],
    invertMapTextColour: true
  },
  {
    name: 'Relief Wallonie – MNT 2021-2022 Hillshade',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/RELIEF/WALLONIE_MNT_2021_2022_HILLSHADE/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'Hillshade MNT 2021-2022' }],
    invertMapTextColour: true
  },
  {
    name: 'Limites administratives Wallonie',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/LIMITES/LIMITES_ADMINISTRATIVES/MapServer/WMSServer',
    minScaleDenominator: 236.235119,
    sublayers: [
      { id: '0', title: 'Commune' },
      { id: '1', title: 'Arrondissement administratif' },
      { id: '2', title: 'Province' },
      { id: '3', title: 'Région' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Grootschalig Referentiebestand',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/GRB-basiskaart/wms',
    sublayers: [{ id: 'GRB_BSK', title: 'GRB-basiskaart' }]
  },
  {
    // Digitaal Vlaanderen keeps this mosaic on the newest winter flight per area, so it never ages
    name: 'Luchtfoto Vlaanderen – meest recent (winter)',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/OMWRGBMRVL/wms',
    sublayers: [{ id: 'Ortho', title: 'Kleur, meest recent' }],
    invertMapTextColour: false
  },
  {
    name: 'Luchtfoto Vlaanderen 2024 Zomer',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/OMZ/wms',
    sublayers: [
      { id: 'OMZNIR24VL', title: 'Infrarood' },
      { id: 'OMZPAN24VL', title: 'Zwart-wit' },
      { id: 'OMZRGB24VL', title: 'Kleur' }
    ],
    invertMapTextColour: false
  },
  {
    name: 'Luchtfoto Vlaanderen 1971 - 1990 Zomer',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/OKZ/wms',
    sublayers: [
      { id: 'OKZRGB79_90VL', title: 'Zomer 1979-1990 - kleur' },
      { id: 'OKZPAN71VL', title: 'Zomer 1971 - zwart-wit' }
    ],
    invertMapTextColour: false
  },
  {
    name: 'UrbIS Brussel basiskaart',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices-urbis.irisnet.be/geoserver/BaseMaps/wms',
    sublayers: [{ id: 'UrbISFrenchDutchLabeledColor', title: 'UrbIS FR/NL' }],
    invertMapTextColour: true
  },
  {
    // UrbIS keeps 'Ortho' on the newest flight over Brussels
    name: 'Luchtfoto Brussel – meest recent',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices-urbis.irisnet.be/geoserver/urbisgrid/wms',
    sublayers: [{ id: 'Ortho', title: 'Kleur, meest recent' }],
    invertMapTextColour: false
  },
  {
    name: 'Opnamedatum luchtfoto Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/OMWRGBMRVL/wms',
    sublayers: [{ id: 'Vliegdagcontour', title: 'Vliegdagcontour meest recente winteropname' }]
  },
  {
    name: 'Grondwaterstandindicator Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.dov.vlaanderen.be/geoserver/wms',
    sublayers: [{ id: 'gw_varia:stand_freatisch', title: 'Grondwaterstandindicator' }]
  },
  {
    name: 'Grondwaterlichamen Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.dov.vlaanderen.be/geoserver/wms',
    sublayers: [{ id: 'gw_beleid:gwlichamen', title: 'Grondwaterlichamen' }],
    invertMapTextColour: false
  },
  {
    name: 'Bodemtypes Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.dov.vlaanderen.be/geoserver/wms',
    sublayers: [{ id: 'bodemkaart:bodemtypes', title: 'Bodemtypes (min:100k)' }],
    invertMapTextColour: true
  },
  {
    name: 'Grondmonsters Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.dov.vlaanderen.be/geoserver/wms',
    sublayers: [{ id: 'boringen:grondmonsters', title: 'Grondmonsters (min:60k)' }]
  },
  {
    name: 'Bodembedekkingsbestanden 2018',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/BodemgebruikBodembedekking/wms',
    sublayers: [
      { id: 'BAK5_18', title: 'Bodemafdekkingskaart (BAK) 5m' },
      { id: 'WOK5_18', title: 'Waterondoorlaatbaarheidskaart (WOK) 5m' },
      { id: 'BBK1_18', title: 'Bodembedekkingskaart (BBK) 1m' }
    ]
  },
  // Land-use plans: the bestemming sets the bestemmingstype / type d'usage and so the soil standards
  {
    name: 'Gewestplan Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.mercator.vlaanderen.be/raadpleegdienstenmercatorpubliek/ows',
    sublayers: [
      { id: 'lu:lu_gwp_gv', title: 'Bestemmingen' },
      { id: 'lu:lu_gwp_ov', title: 'Overdrukken' },
      { id: 'lu:lu_gwp_ln', title: 'Lijnen (min:100k)' }
    ],
    invertMapTextColour: true
  },
  {
    // Drawn over the gewestplan, because a RUP replaces it where one applies
    name: "RUP's Vlaanderen",
    type: 'WMS',
    country: 'BE',
    url: 'https://www.mercator.vlaanderen.be/raadpleegdienstenmercatorpubliek/ows',
    sublayers: [
      { id: 'lu:lu_gewrup_gv', title: 'Gewestelijke RUP (min:100k)' },
      { id: 'lu:lu_prorup_gv', title: 'Provinciale RUP (min:100k)' },
      { id: 'lu:lu_gemrup_gv', title: 'Gemeentelijke RUP' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Plan de secteur Wallonie',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/AMENAGEMENT_TERRITOIRE/PDS/MapServer/WMSServer',
    sublayers: [{ id: '2', title: "Zones d'affectation (min:236k)" }],
    invertMapTextColour: true
  },
  {
    name: 'Geologische kaart Vlaanderen (Tertiair)',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.dov.vlaanderen.be/geoserver/wms',
    minScaleDenominator: 200,
    sublayers: [{ id: 'dov-pub-ALBON_DUT_Geology:BE-VLG_ALBON_NL_50k_GeolUNITS', title: 'Tertiaire lithostratigrafie 1:50.000' }],
    invertMapTextColour: true
  },
  {
    name: 'Carte géologique Wallonie',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/SOL_SOUS_SOL/CARTE_GEOLOGIQUE_SIMPLE/MapServer/WMSServer',
    minScaleDenominator: 4724.702381,
    sublayers: [
      { id: '2', title: 'Unités lithostratigraphiques (1:5k – 1:189k)' },
      { id: '4', title: 'Limites (1:5k – 1:47k)' },
      { id: '7', title: 'Failles (1:5k – 1:94k)' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Carte des sols Wallonie',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/SOL_SOUS_SOL/CNSW/MapServer/WMSServer',
    sublayers: [
      { id: '1', title: 'Séries, variantes, phases (1:5k – 1:24k)' },
      { id: '0', title: 'Séries, variantes, phases (< 1:5k)' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Contraintes karstiques Wallonie',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/AMENAGEMENT_TERRITOIRE/CONTR_KARST/MapServer/WMSServer',
    minScaleDenominator: 236.235119,
    sublayers: [{ id: '0', title: 'Zones de contraintes karstiques' }]
  },
  {
    name: "Aléa d'inondation Wallonie",
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/EAU/ALEA_INOND/MapServer/WMSServer',
    sublayers: [
      { id: '6', title: 'Débordement et ruissellement (> 1:24k)' },
      { id: '5', title: 'Débordement et ruissellement (1:5k – 1:24k)' },
      { id: '4', title: 'Débordement et ruissellement (< 1:5k)' }
    ]
  },
  {
    name: 'Overstromingskaart Brussel',
    type: 'WMS',
    country: 'BE',
    url: 'https://wms.environnement.brussels/be_wms',
    sublayers: [{ id: 'flood_hazardmap_2019_scale_1_10000', title: 'Overstromingsgevaar 2019 (1:10.000)' }]
  },
  {
    name: 'Beschermingszones grondwaterwinning Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.dov.vlaanderen.be/geoserver/wms',
    sublayers: [{ id: 'gw_bescherming:beschermingszones', title: 'Waterwingebieden en beschermingszones' }]
  },
  {
    name: 'Zones de prévention captages Wallonie',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/EAU/PROTECT_CAPT/MapServer/WMSServer',
    minScaleDenominator: 944.940476,
    sublayers: [
      { id: '4', title: 'Zones de surveillance (min:236k)' },
      { id: '2', title: 'Prévention éloignée IIb (min:236k)' },
      { id: '3', title: 'Prévention rapprochée IIa (min:236k)' },
      { id: '0', title: 'Prévention forfaitaires (min:236k)' }
    ]
  },
  {
    name: 'Beschermingszones waterwinning Brussel',
    type: 'WMS',
    country: 'BE',
    url: 'https://wms.environnement.brussels/be_wms',
    sublayers: [{ id: 'bruenvi_water_protectedsite_drinking_water', title: 'Beschermingszones 2 en 3' }]
  },
  {
    name: 'Natura 2000 en VEN Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.mercator.vlaanderen.be/raadpleegdienstenmercatorpubliek/ows',
    sublayers: [
      { id: 'ps:ps_hbtrl', title: 'Habitatrichtlijngebieden' },
      { id: 'ps:ps_vglrl', title: 'Vogelrichtlijngebieden' },
      { id: 'ps:ps_ven', title: 'VEN en IVON' }
    ]
  },
  {
    name: 'Beschermd erfgoed Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.mercator.vlaanderen.be/raadpleegdienstenmercatorpubliek/ows',
    sublayers: [
      { id: 'ps:ps_bes_land', title: 'Cultuurhistorische landschappen' },
      { id: 'ps:ps_bes_sd_gezicht', title: 'Stads- en dorpsgezichten' },
      { id: 'ps:ps_bes_arch_site', title: 'Archeologische sites' },
      { id: 'ps:ps_bes_monument', title: 'Monumenten' }
    ]
  },
  // Soil inventories: the starting point of every investigation in Wallonia and Brussels
  {
    name: 'BDES – état des sols Wallonie',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/SOL_SOUS_SOL/BDES_INVENTAIRE/MapServer/WMSServer',
    minScaleDenominator: 236.235119,
    sublayers: [
      { id: '0', title: 'Informations indicatives, art. 12 §4 (min:61k)' },
      { id: '1', title: 'Démarches de gestion des sols, art. 12 §2-3 (min:61k)' }
    ]
  },
  {
    name: 'Inventaris bodemtoestand Brussel',
    type: 'WMS',
    country: 'BE',
    url: 'https://wms.environnement.brussels/be_wms',
    sublayers: [{ id: 'inventaire_etat_sol_public', title: 'Inventaris van de bodemtoestand' }]
  },
  {
    name: 'Boringen en sonderingen Vlaanderen (DOV)',
    type: 'WMS',
    country: 'BE',
    url: 'https://www.dov.vlaanderen.be/geoserver/wms',
    sublayers: [
      { id: 'dov-pub:Boringen', title: 'Boringen (min:50k)' },
      { id: 'dov-pub:Sonderingen', title: 'Sonderingen (min:50k)' }
    ]
  },
  // Parcels and addresses last, so they draw over the photos and the area maps above
  {
    name: 'Kadastrale percelen Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/Adpf/wms',
    sublayers: [
      { id: 'GrAdpf', title: 'Perceelgrenzen (recentste fiscale toestand)' },
      { id: 'LblAdpf', title: 'Perceelnummers' }
    ]
  },
  {
    name: 'Parcelles cadastrales Wallonie',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices.wallonie.be/arcgis/services/PLAN_REGLEMENT/CADMAP_PARCELLES/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'Parcelles, dernière situation (min:24k)' }],
    invertMapTextColour: true
  },
  {
    name: 'Kadastrale percelen Brussel',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices-urbis.irisnet.be/geoserver/UrbisAdm/wms',
    sublayers: [{ id: 'Capa', title: 'Kadastrale percelen' }]
  },
  {
    name: 'Adressen Vlaanderen',
    type: 'WMS',
    country: 'BE',
    url: 'https://geo.api.vlaanderen.be/Adressenregister/wms',
    sublayers: [{ id: 'A_INGEBRUIK', title: 'Adressen in gebruik' }]
  },
  {
    name: 'Adressen Brussel',
    type: 'WMS',
    country: 'BE',
    url: 'https://geoservices-urbis.irisnet.be/geoserver/UrbisAdm/wms',
    sublayers: [{ id: 'Adpt', title: 'Adrespunten (min:1.5k)' }]
  }
]
